import * as React from 'react';
import b from 'b_';
import cn from 'classnames';

import './index.scss';

interface Props extends React.HTMLProps<HTMLDivElement> {
  big?: boolean;
  hidden?: boolean;
  classNames?: string;
}

export default ({ big, hidden, className, ...props }: Props) => (
  <div className={cn(className, b('pulse-loading', { big, hidden }))} {...props} />
);
